// Legacy webinterface locale/currency prefix mapping.
//
// The legacy webinterface serves its pages under locale/currency path
// prefixes (e.g. `/de/terms`, `/us/en/terms`, `/gb/privacy`), NOT under the
// coarse business region code (`eur`/`int`). This pure mapping turns the
// current i18n locale + selected currency into the correct legacy prefix.
//
// Kept as a pure helper (no reactivity, no store access) so it can be reused
// from composables, components and the footer, and unit-tested standalone —
// see specs/03-website/frontend-conventions.md "Store vs Composable vs Helper"
// (pure function / shared constant -> Helper).

const localeOverrideMapping: Record<string, Record<string, string>> = {
  de: {
    EUR: 'de',
    USD: 'us/en',
    JPY: 'ja',
    GBP: 'gb',
    AUD: 'us/en',
  },
  en: {
    EUR: 'en',
    USD: 'us/en',
    JPY: 'ja',
    GBP: 'gb',
    AUD: 'us/en',
  },
  fr: {
    EUR: 'fr',
    USD: 'us/en',
    JPY: 'ja',
    GBP: 'gb',
    AUD: 'us/en',
  },
  it: {
    EUR: 'it',
    USD: 'us/en',
    JPY: 'ja',
    GBP: 'gb',
    AUD: 'us/en',
  },
  pl: {
    EUR: 'pl',
    USD: 'us/en',
    JPY: 'ja',
    GBP: 'gb',
    AUD: 'us/en',
  },
  es: {
    EUR: 'es',
    USD: 'us/en',
    JPY: 'ja',
    GBP: 'gb',
    AUD: 'us/en',
  },
  pt: {
    EUR: 'pt',
    USD: 'us/en',
    JPY: 'ja',
    GBP: 'gb',
    AUD: 'us/en',
  },
  nl: {
    EUR: 'nl',
    USD: 'us/en',
    JPY: 'ja',
    GBP: 'gb',
    AUD: 'us/en',
  },
  ru: {
    EUR: 'en',
    USD: 'us/en',
    JPY: 'ja',
    GBP: 'gb',
    AUD: 'us/en',
  },
  ja: {
    EUR: 'en',
    USD: 'us/en',
    JPY: 'ja',
    GBP: 'gb',
    AUD: 'us/en',
  },
  zh: {
    EUR: 'en',
    USD: 'zh',
    JPY: 'ja',
    GBP: 'gb',
    AUD: 'us/en',
  },
};

export const getLegacyLocalePrefix = (
  locale: string,
  currency: string,
): string => {
  if (
    locale in localeOverrideMapping &&
    currency in localeOverrideMapping[locale]
  ) {
    return localeOverrideMapping[locale][currency];
  }
  return 'en';
};
